export function getCookieValue(key: string): string | undefined {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    // Dynamic import for server-side code
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { cookies } = require('next/headers');
    return cookies().get(key)?.value;
  }

  // Dynamic import for client-side code
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const Cookies = require('js-cookie');
  return Cookies.get(key);
}
